RivalIQ.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.Localizable = Marionette.Behavior.extend({
        str: RivalIQ.str,

        initialize: function () {
            const me = this;
            const view = me.view;
            const templateHelpers = view.templateHelpers;
            view.templateHelpers = function () {
                let helpers = templateHelpers;

                if (_.isFunction(templateHelpers)) {
                    helpers = templateHelpers.call(view);
                }

                return _.extend({
                    str: me.str
                }, helpers);
            };
        }
    });

});
